import { ComponentChildren, createContext, JSX } from 'preact'
import { useContext, useMemo, useState } from 'preact/hooks'
import { CSSRule } from '@gsc/types'
import { StyleRegistry } from './StyleRegistry'

interface Props {
  children: ComponentChildren
}

export const StyleRegistryContext = createContext<StyleRegistry | undefined>(undefined)
export const StyleRegistryStateContext = createContext<CSSRule[] | undefined>(undefined)

export function StyleRegistryProvider({ children }: Props): JSX.Element {
  const [styles, setStyles] = useState<CSSRule[]>([])

  const registry = useMemo<StyleRegistry>(
    () => ({
      add: (style: CSSRule) => {
        setStyles(currStyles => {
          const idx = currStyles.findIndex(s => s.id === style.id)
          return idx > -1 ? [...currStyles.slice(0, idx), style, ...currStyles.slice(idx + 1)] : [...currStyles, style]
        })
      },

      remove: (id: string) => {
        setStyles(currStyles => currStyles.filter(s => s.id !== id))
      },
    }),
    [],
  )

  return (
    <StyleRegistryContext.Provider value={registry}>
      <StyleRegistryStateContext.Provider value={styles}>{children}</StyleRegistryStateContext.Provider>
    </StyleRegistryContext.Provider>
  )
}

export const useStyleRegistry = (): StyleRegistry | undefined => useContext(StyleRegistryContext)

export const useStyleRegistryState = (): CSSRule[] | undefined => useContext(StyleRegistryStateContext)
